export default __webpack_public_path__ + "static/media/Adling_Wedding-testimonial.092b99da.webp";